import { BookYearService } from "@/services/book-year-service";

export class SalesSaveAsData{
	saleIds:number[] = []
	toBookYear:number = BookYearService.selectedBookYear;
	saveAsTypeId:number = 0;
	toJournalId:number = 0;
	saveAs1Document:boolean = false;
	deleteOriginalDocuments:boolean = false;
	beginDate:Date = new Date();
	clientID:number = 0;
	vatRegime:number = 0;
	makeNegative:boolean = false;
	computeStock:boolean = false;
	createNegativeStockIns:boolean = false;
	useTodaysDate:boolean = false;
	keepSameNumbers:boolean = false;
	addImportedFromSaleText:boolean = false;

	public getJSON():any{
		return {
			SaleIDs: [...this.saleIds],
			ToBookYear: this.toBookYear,
			SaveAsTypeID: this.saveAsTypeId,
			ToJournalID: this.toJournalId,
			SaveAs1Document: this.saveAs1Document,
			DeleteOriginalDocuments: this.deleteOriginalDocuments,
			BeginDate: this.beginDate,
			ClientID: this.clientID,
			VatRegime: this.vatRegime,
			MakeNegative: this.makeNegative,
			ComputeStock: this.computeStock,
			CreateNegativeStockIns: this.createNegativeStockIns,
			UseTodaysDate: this.useTodaysDate,
			KeepSameNumbers: this.keepSameNumbers,
			AddImportedFromSaleText: this.addImportedFromSaleText
		};
	}
}